import type { KeyboardEvent } from "react";

export interface DialogProps {
	open?: boolean;
	setOpen: (state: boolean) => void;
	trigger?: JSX.Element;
	content: JSX.Element;
	title?: string;
	size?: DialogSize;
	/**
	 * Keys pressed on the dialog itself, which is where focus sits when the agent has clicked the dialog
	 * rather than anything in it. Keys pressed on a control inside bubble through here too, so a handler
	 * that only means the dialog should compare the event's target against its currentTarget.
	 */
	onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void;
}

export enum DialogSize {
	Small = 1,
	Medium = 2,
	Large = 3
}

export interface ConfirmationDialogProps {
	open: boolean;
	setOpen: any;
	text: string;
	onConfirm: () => void;
	onCancel: () => void;
}

export interface GlobalDialogContextType {
	showDialog: (title: string, content: JSX.Element) => void;
	hideDialog: () => void;
}

export interface GlobalDialogProviderProps {
	children: JSX.Element;
}
